import { Link } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center bg-background [background-image:radial-gradient(var(--border)_1px,transparent_1px)] [background-size:24px_24px]">
      {/* Logo */}
      <Link to="/" className="mb-10">
        <img
          src="/StackSketch-FullLogo.svg"
          alt="Stack Sketch"
          className="h-8 w-auto dark:brightness-0 dark:invert"
        />
      </Link>

      {/* Decorative 404 */}
      <p className="select-none text-[130px] sm:text-[180px] font-bold leading-none tracking-tighter text-muted-foreground/25">
        404
      </p>

      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground">
        Page not found
      </h1>
      <p className="mt-2 max-w-md text-[15px] text-muted-foreground">
        The page you&rsquo;re looking for doesn&rsquo;t exist or may have been moved.
      </p>

      <Link
        to="/"
        className="ss-press mt-7 inline-flex items-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition-colors hover:bg-primary/90"
      >
        Back to home
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
